// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AgentRunsGetData, AgentRunsGetErrors, AgentRunsGetResponses, AgentRunsListData, AgentRunsListErrors, AgentRunsListResponses, AgentsActivateData, AgentsActivateErrors, AgentsActivateResponses, AgentsCreateVersionData, AgentsCreateVersionErrors, AgentsCreateVersionResponses, AgentsGetData, AgentsGetErrors, AgentsGetResponses, AgentsListData, AgentsListResponses, AgentsVersionsData, AgentsVersionsErrors, AgentsVersionsResponses, CalendarEventsListData, CalendarEventsListErrors, CalendarEventsListResponses, GoogleCalendarWebhookNotifyData, GoogleCalendarWebhookNotifyErrors, GoogleCalendarWebhookNotifyResponses, GoogleOAuthCallbackData, GoogleOAuthCallbackErrors, GoogleOAuthCallbackResponses, GoogleOAuthStartData, GoogleOAuthStartErrors, GoogleOAuthStartResponses, HealthHealthData, HealthHealthResponses, JobsDescribeData, JobsDescribeResponses, JobsRunData, JobsRunResponses, JobsSyncData, JobsSyncResponses, MeMeData, MeMeErrors, MeMeResponses, PersonaConnectionsListData, PersonaConnectionsListErrors, PersonaConnectionsListResponses, PersonaConnectionsUnlinkData, PersonaConnectionsUnlinkErrors, PersonaConnectionsUnlinkResponses, PersonasCreateData, PersonasCreateErrors, PersonasCreateResponses, PersonasGetData, PersonasGetErrors, PersonasGetResponses, PersonasListData, PersonasListResponses, PersonasRemoveData, PersonasRemoveErrors, PersonasRemoveResponses, PersonasUpdateData, PersonasUpdateErrors, PersonasUpdateResponses, PlanningListData, PlanningListErrors, PlanningListResponses, PlanningPlanData, PlanningPlanErrors, PlanningPlanResponses, RealtimeTokenData, RealtimeTokenResponses, TaskCaptureCreateData, TaskCaptureCreateErrors, TaskCaptureCreateResponses, TasksCreateData, TasksCreateErrors, TasksCreateResponses, TasksListData, TasksListErrors, TasksListResponses, TasksRemoveData, TasksRemoveErrors, TasksRemoveResponses, TasksUpdateData, TasksUpdateErrors, TasksUpdateResponses, UsersListData, UsersListResponses, UsersSetPersonasData, UsersSetPersonasErrors, UsersSetPersonasResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get an Ably token request
 *
 * Signed by the API. Lets the browser subscribe to Sage's `sage:*` channels for an hour. It can't publish.
 */
export const realtimeToken = <ThrowOnError extends boolean = false>(options?: Options<RealtimeTokenData, ThrowOnError>): RequestResult<RealtimeTokenResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RealtimeTokenResponses, unknown, ThrowOnError>({ url: '/realtime/token', ...options });

/**
 * List agents
 */
export const agentsList = <ThrowOnError extends boolean = false>(options?: Options<AgentsListData, ThrowOnError>): RequestResult<AgentsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AgentsListResponses, unknown, ThrowOnError>({ url: '/agents', ...options });

/**
 * Get an agent
 */
export const agentsGet = <ThrowOnError extends boolean = false>(options: Options<AgentsGetData, ThrowOnError>): RequestResult<AgentsGetResponses, AgentsGetErrors, ThrowOnError> => (options.client ?? client).get<AgentsGetResponses, AgentsGetErrors, ThrowOnError>({ url: '/agents/{id}', ...options });

/**
 * List an agent's prompt versions
 *
 * Newest first.
 */
export const agentsVersions = <ThrowOnError extends boolean = false>(options: Options<AgentsVersionsData, ThrowOnError>): RequestResult<AgentsVersionsResponses, AgentsVersionsErrors, ThrowOnError> => (options.client ?? client).get<AgentsVersionsResponses, AgentsVersionsErrors, ThrowOnError>({ url: '/agents/{id}/versions', ...options });

/**
 * Save a new prompt version
 *
 * Versions are never changed. Saving adds the next one and, unless `activate` is false, makes runs use it.
 */
export const agentsCreateVersion = <ThrowOnError extends boolean = false>(options: Options<AgentsCreateVersionData, ThrowOnError>): RequestResult<AgentsCreateVersionResponses, AgentsCreateVersionErrors, ThrowOnError> => (options.client ?? client).post<AgentsCreateVersionResponses, AgentsCreateVersionErrors, ThrowOnError>({
    url: '/agents/{id}/versions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Use a prompt version
 *
 * Makes runs use this version, e.g. to roll back to an earlier one.
 */
export const agentsActivate = <ThrowOnError extends boolean = false>(options: Options<AgentsActivateData, ThrowOnError>): RequestResult<AgentsActivateResponses, AgentsActivateErrors, ThrowOnError> => (options.client ?? client).post<AgentsActivateResponses, AgentsActivateErrors, ThrowOnError>({ url: '/agents/{id}/versions/{versionId}/activate', ...options });

/**
 * List agent runs
 *
 * Newest first. Follow a run live on the `sage:agent-runs` Ably channel (`run.updated`).
 */
export const agentRunsList = <ThrowOnError extends boolean = false>(options?: Options<AgentRunsListData, ThrowOnError>): RequestResult<AgentRunsListResponses, AgentRunsListErrors, ThrowOnError> => (options?.client ?? client).get<AgentRunsListResponses, AgentRunsListErrors, ThrowOnError>({ url: '/agent-runs', ...options });

/**
 * Get an agent run
 */
export const agentRunsGet = <ThrowOnError extends boolean = false>(options: Options<AgentRunsGetData, ThrowOnError>): RequestResult<AgentRunsGetResponses, AgentRunsGetErrors, ThrowOnError> => (options.client ?? client).get<AgentRunsGetResponses, AgentRunsGetErrors, ThrowOnError>({ url: '/agent-runs/{id}', ...options });

/**
 * List personas
 */
export const personasList = <ThrowOnError extends boolean = false>(options?: Options<PersonasListData, ThrowOnError>): RequestResult<PersonasListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PersonasListResponses, unknown, ThrowOnError>({ url: '/personas', ...options });

/**
 * Create a persona
 */
export const personasCreate = <ThrowOnError extends boolean = false>(options: Options<PersonasCreateData, ThrowOnError>): RequestResult<PersonasCreateResponses, PersonasCreateErrors, ThrowOnError> => (options.client ?? client).post<PersonasCreateResponses, PersonasCreateErrors, ThrowOnError>({
    url: '/personas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a persona
 *
 * Soft delete: the persona is hidden but kept in the database.
 */
export const personasRemove = <ThrowOnError extends boolean = false>(options: Options<PersonasRemoveData, ThrowOnError>): RequestResult<PersonasRemoveResponses, PersonasRemoveErrors, ThrowOnError> => (options.client ?? client).delete<PersonasRemoveResponses, PersonasRemoveErrors, ThrowOnError>({ url: '/personas/{id}', ...options });

/**
 * Get a persona
 */
export const personasGet = <ThrowOnError extends boolean = false>(options: Options<PersonasGetData, ThrowOnError>): RequestResult<PersonasGetResponses, PersonasGetErrors, ThrowOnError> => (options.client ?? client).get<PersonasGetResponses, PersonasGetErrors, ThrowOnError>({ url: '/personas/{id}', ...options });

/**
 * Update a persona
 *
 * Changes only the fields sent.
 */
export const personasUpdate = <ThrowOnError extends boolean = false>(options: Options<PersonasUpdateData, ThrowOnError>): RequestResult<PersonasUpdateResponses, PersonasUpdateErrors, ThrowOnError> => (options.client ?? client).patch<PersonasUpdateResponses, PersonasUpdateErrors, ThrowOnError>({
    url: '/personas/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List users
 *
 * Everyone who has signed in, with the personas that are theirs.
 */
export const usersList = <ThrowOnError extends boolean = false>(options?: Options<UsersListData, ThrowOnError>): RequestResult<UsersListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsersListResponses, unknown, ThrowOnError>({ url: '/users', ...options });

/**
 * Set a user's personas
 *
 * Replaces the user's personas with exactly the ones sent. Anyone can set anyone's.
 */
export const usersSetPersonas = <ThrowOnError extends boolean = false>(options: Options<UsersSetPersonasData, ThrowOnError>): RequestResult<UsersSetPersonasResponses, UsersSetPersonasErrors, ThrowOnError> => (options.client ?? client).put<UsersSetPersonasResponses, UsersSetPersonasErrors, ThrowOnError>({
    url: '/users/{id}/personas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The signed-in user
 */
export const meMe = <ThrowOnError extends boolean = false>(options?: Options<MeMeData, ThrowOnError>): RequestResult<MeMeResponses, MeMeErrors, ThrowOnError> => (options?.client ?? client).get<MeMeResponses, MeMeErrors, ThrowOnError>({ url: '/me', ...options });

/**
 * Inngest endpoint
 *
 * Inngest calls this to list and run Sage's background jobs. It's public, but Inngest signs every request and the SDK rejects unsigned ones (outside local dev).
 */
export const jobsDescribe = <ThrowOnError extends boolean = false>(options?: Options<JobsDescribeData, ThrowOnError>): RequestResult<JobsDescribeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<JobsDescribeResponses, unknown, ThrowOnError>({ url: '/inngest', ...options });

/**
 * Inngest endpoint
 *
 * Inngest calls this to list and run Sage's background jobs. It's public, but Inngest signs every request and the SDK rejects unsigned ones (outside local dev).
 */
export const jobsRun = <ThrowOnError extends boolean = false>(options?: Options<JobsRunData, ThrowOnError>): RequestResult<JobsRunResponses, unknown, ThrowOnError> => (options?.client ?? client).post<JobsRunResponses, unknown, ThrowOnError>({ url: '/inngest', ...options });

/**
 * Inngest endpoint
 *
 * Inngest calls this to list and run Sage's background jobs. It's public, but Inngest signs every request and the SDK rejects unsigned ones (outside local dev).
 */
export const jobsSync = <ThrowOnError extends boolean = false>(options?: Options<JobsSyncData, ThrowOnError>): RequestResult<JobsSyncResponses, unknown, ThrowOnError> => (options?.client ?? client).put<JobsSyncResponses, unknown, ThrowOnError>({ url: '/inngest', ...options });

/**
 * Start connecting a Google account
 *
 * Returns Google's consent page for the browser to go to, and sets a 10 minute cookie the callback checks.
 */
export const googleOAuthStart = <ThrowOnError extends boolean = false>(options: Options<GoogleOAuthStartData, ThrowOnError>): RequestResult<GoogleOAuthStartResponses, GoogleOAuthStartErrors, ThrowOnError> => (options.client ?? client).post<GoogleOAuthStartResponses, GoogleOAuthStartErrors, ThrowOnError>({
    url: '/connections/google/start',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Google OAuth callback
 *
 * Google sends the browser here. Saves the account, links it to the persona, then redirects (303) to the persona's page with `?connected=<id>`, or to `/personas?connectionError=<message>` if it failed.
 */
export const googleOAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<GoogleOAuthCallbackData, ThrowOnError>): RequestResult<GoogleOAuthCallbackResponses, GoogleOAuthCallbackErrors, ThrowOnError> => (options?.client ?? client).get<GoogleOAuthCallbackResponses, GoogleOAuthCallbackErrors, ThrowOnError>({ url: '/connections/google/callback', ...options });

/**
 * List a persona's connections
 */
export const personaConnectionsList = <ThrowOnError extends boolean = false>(options: Options<PersonaConnectionsListData, ThrowOnError>): RequestResult<PersonaConnectionsListResponses, PersonaConnectionsListErrors, ThrowOnError> => (options.client ?? client).get<PersonaConnectionsListResponses, PersonaConnectionsListErrors, ThrowOnError>({ url: '/personas/{id}/connections', ...options });

/**
 * Unlink a connection from a persona
 *
 * Other personas keep it. Once no persona uses it, the connection is deleted.
 */
export const personaConnectionsUnlink = <ThrowOnError extends boolean = false>(options: Options<PersonaConnectionsUnlinkData, ThrowOnError>): RequestResult<PersonaConnectionsUnlinkResponses, PersonaConnectionsUnlinkErrors, ThrowOnError> => (options.client ?? client).delete<PersonaConnectionsUnlinkResponses, PersonaConnectionsUnlinkErrors, ThrowOnError>({ url: '/personas/{id}/connections/{connectionId}', ...options });

/**
 * List calendar events
 *
 * Events from every enabled calendar of the personas asked for (all personas if none), that overlap `from` to `to`. For one day in the user's time zone, send its local midnights.
 */
export const calendarEventsList = <ThrowOnError extends boolean = false>(options: Options<CalendarEventsListData, ThrowOnError>): RequestResult<CalendarEventsListResponses, CalendarEventsListErrors, ThrowOnError> => (options.client ?? client).get<CalendarEventsListResponses, CalendarEventsListErrors, ThrowOnError>({ url: '/calendar/events', ...options });

/**
 * Google Calendar change notification
 *
 * Google calls this when a watched calendar changes. It's public, so the channel token Google echoes back (an HMAC of the channel id) is checked. A known channel queues a sync of its connection.
 */
export const googleCalendarWebhookNotify = <ThrowOnError extends boolean = false>(options?: Options<GoogleCalendarWebhookNotifyData, ThrowOnError>): RequestResult<GoogleCalendarWebhookNotifyResponses, GoogleCalendarWebhookNotifyErrors, ThrowOnError> => (options?.client ?? client).post<GoogleCalendarWebhookNotifyResponses, GoogleCalendarWebhookNotifyErrors, ThrowOnError>({ url: '/webhooks/google-calendar', ...options });

/**
 * Liveness check
 */
export const healthHealth = <ThrowOnError extends boolean = false>(options?: Options<HealthHealthData, ThrowOnError>): RequestResult<HealthHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthHealthResponses, unknown, ThrowOnError>({ url: '/healthz', ...options });

/**
 * List tasks
 *
 * Open tasks first (soonest due, then most important), then done ones (latest first). Changes arrive live on the `sage:tasks` Ably channel.
 */
export const tasksList = <ThrowOnError extends boolean = false>(options?: Options<TasksListData, ThrowOnError>): RequestResult<TasksListResponses, TasksListErrors, ThrowOnError> => (options?.client ?? client).get<TasksListResponses, TasksListErrors, ThrowOnError>({ url: '/tasks', ...options });

/**
 * Add a task
 */
export const tasksCreate = <ThrowOnError extends boolean = false>(options: Options<TasksCreateData, ThrowOnError>): RequestResult<TasksCreateResponses, TasksCreateErrors, ThrowOnError> => (options.client ?? client).post<TasksCreateResponses, TasksCreateErrors, ThrowOnError>({
    url: '/tasks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a task
 *
 * Soft delete: the task is hidden but kept in the database.
 */
export const tasksRemove = <ThrowOnError extends boolean = false>(options: Options<TasksRemoveData, ThrowOnError>): RequestResult<TasksRemoveResponses, TasksRemoveErrors, ThrowOnError> => (options.client ?? client).delete<TasksRemoveResponses, TasksRemoveErrors, ThrowOnError>({ url: '/tasks/{id}', ...options });

/**
 * Update a task
 *
 * Changes only the fields sent. Send `done: true` to tick it off, or `false` to reopen it.
 */
export const tasksUpdate = <ThrowOnError extends boolean = false>(options: Options<TasksUpdateData, ThrowOnError>): RequestResult<TasksUpdateResponses, TasksUpdateErrors, ThrowOnError> => (options.client ?? client).patch<TasksUpdateResponses, TasksUpdateErrors, ThrowOnError>({
    url: '/tasks/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Turn text into tasks
 *
 * Queues a run of the task capture agent, which adds, changes or ticks off tasks from the text, and returns its id straight away. Follow the run on the `sage:agent-runs` Ably channel or at `GET /agent-runs/{id}`; tasks it changes arrive on `sage:tasks`.
 */
export const taskCaptureCreate = <ThrowOnError extends boolean = false>(options: Options<TaskCaptureCreateData, ThrowOnError>): RequestResult<TaskCaptureCreateResponses, TaskCaptureCreateErrors, ThrowOnError> => (options.client ?? client).post<TaskCaptureCreateResponses, TaskCaptureCreateErrors, ThrowOnError>({
    url: '/tasks/capture',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List planned task blocks
 *
 * Time the day planner set aside for tasks, on the days from `from` to `to` (inclusive), in start order. Changes arrive live on the `sage:planning` Ably channel.
 */
export const planningList = <ThrowOnError extends boolean = false>(options: Options<PlanningListData, ThrowOnError>): RequestResult<PlanningListResponses, PlanningListErrors, ThrowOnError> => (options.client ?? client).get<PlanningListResponses, PlanningListErrors, ThrowOnError>({ url: '/planning/blocks', ...options });

/**
 * Plan a day
 *
 * Queues a run of the day planner agent, which fits the day's tasks into its free time, and returns its id straight away. Follow the run on the `sage:agent-runs` Ably channel or at `GET /agent-runs/{id}`; the new plan arrives on `sage:planning`.
 */
export const planningPlan = <ThrowOnError extends boolean = false>(options: Options<PlanningPlanData, ThrowOnError>): RequestResult<PlanningPlanResponses, PlanningPlanErrors, ThrowOnError> => (options.client ?? client).post<PlanningPlanResponses, PlanningPlanErrors, ThrowOnError>({ url: '/planning/days/{day}/plan', ...options });
